import {ORDERBOOK} from 'actions'
import produce from 'immer'
import {updateOrders} from 'utils/orderbook'

const reducer = (state = {}, {
  type, symbol, response, isFull
}) => {
  if (type === ORDERBOOK) {
    // TODO: deal with zero data which is not existed in response
    const nextState = produce(state, draftState => {
      updateOrders(symbol, draftState, response, isFull)
    })
    return nextState
  }
  return state
}

export default reducer
